import CreatePollModal from "./CreatePollModal";

export default CreatePollModal;
